// Mock data for TenSolar Energy website

export const mockContactSubmission = async (formData) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  console.log('Mock Contact Form Submission:', formData);
  
  // Store in localStorage for demo purposes
  const existingSubmissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
  existingSubmissions.push({
    ...formData,
    timestamp: new Date().toISOString(),
    id: Date.now()
  });
  localStorage.setItem('contactSubmissions', JSON.stringify(existingSubmissions));
  
  return {
    success: true,
    message: 'Thank you for your interest. We will get back to you soon.'
  };
};

export const getContactSubmissions = () => {
  return JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
};
